export type EventPayload = Record<string, any>;

async function post(path: string, body: any) {
  await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
}

export async function track(event: string, payload: EventPayload = {}) {
  try {
    const anonId = localStorage.getItem('anonId') || crypto.randomUUID();
    localStorage.setItem('anonId', anonId);
    await post('/api/telemetry', { event, payload, anonId });
  } catch {
    // ignore
  }
}

export async function submitLead(name: string, email: string, message?: string) {
  return post('/api/leads', { name, email, message });
}

